import React from "react";
import { Handle, Position } from "@xyflow/react";

interface IProps {
  type: "source" | "target";
  value: string | null | undefined;
}

/*
  Render the source and target cable handles for a node.

  The 'handles' are what the edges connecting nodes in the topological view are connected to.
  The 'source' handle is on the right side of the node (which the start of cables are shown),
  while the 'target' handle is on the left side of the node (where the end of cables are shown).
 */
const HandleRenderer: React.FC<IProps> = ({ type, value }: IProps) => {
  // AgGrid replaces nulls/empty strings with "-"; passing a space here prevents that.
  if (!value) {
    return " ";
  }

  const position = type === "source" ? Position.Right : Position.Left;
  const left = type === "source" ? "0px" : "7px";
  return <Handle type={type} position={position} id={value} style={{ left }} />;
};

export default HandleRenderer;
